import type { Connection } from "@solana/web3.js";

export async function confirmTransactionSignature(
  connection: Connection,
  signature: string,
) {
  await connection.confirmTransaction({
    signature,
    ...(await connection.getLatestBlockhash()),
  });
}
